<template>
  <div class="section-aside__container" data-sticky>
    <div class="section-aside__cont">
      <div class="individual-packing__title">{{ title }}</div>
      <div class="individual-packing__options">

        <div class="individual-packing__options-item accordeon">
          <IPFinalOption v-for="(stage, index) in getFormStages" :key="stage.id" :stage-data="stage" :isOpenDefault="index === 0"/>
        </div>

        <div class="individual-packing__options-item">
          <InputTextarea :placeholder="comment"
                         :label="comment"
                         name="COMMENT"
                         v-model="commentField"
                         :errors="v$.commentField.$errors.concat(v$.quantityField.$errors)"
          />
        </div>
      </div>
    </div>

    <IPAside>
      <template #quantity>
        <div class="quantity quantity--bg">
          <button class="quantity__link quantity__link--minus" @click.prevent="quantityMinus()"></button>
          <input class="quantity__control" min="1" max="999999" step="5"
                 type="text" v-model="this.quantityField" @change="quantityChange" @input="quantityInput">
          <button class="quantity__link quantity__link--plus" @click.prevent="quantityPlus()"></button>
        </div>
      </template>

      <button class="default-btn default-btn--dark" @click.prevent="$emit('prev')">
        <svg class="default-btn__icon" aria-hidden="true">
          <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-arrow-left"></use>
        </svg>
        {{ stageBackTitle }}
      </button>
      <button class="default-btn default-btn--green" :disabled="v$.$dirty && v$.$error" @click.prevent="submitForm">
        {{ stageAddToOrderTitle }}
        <svg class="default-btn__icon" aria-hidden="true">
          <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-plus"></use>
        </svg>
      </button>
    </IPAside>
  </div>
</template>

<script>
import IPAside from "@/components/individual-packing/utils/IPAside.vue";
import InputTextarea from "@/components/utils/formElements/InputTextarea.vue";
import {useIndividualPacking} from "@/hooks/useIndividualPacking";
import IPFinalOption from "@/components/individual-packing/utils/IPFinalOption.vue";
import {IPFieldsView} from "@/mixins/IPFieldsView";
import {useVuelidate} from "@vuelidate/core";
import {helpers, maxLength, maxValue, minValue, required} from "@vuelidate/validators";

export default {
  name: "IPFinalStage",
  emits: ['prev', 'editStage', 'submitForm'],
  mixins: [useIndividualPacking, IPFieldsView],
  components: {IPFinalOption, InputTextarea, IPAside},
  props: {
    stageBackTitle: {
      type: [String],
      default: BX.message('CATALOG_INDIVIDUAL_BACK')
    },
    stageAddToOrderTitle: {
      type: [String],
      default: BX.message('CATALOG_INDIVIDUAL_ADD_TO_ORDER')
    },
    title: {
      type: [String],
      default: BX.message('CATALOG_INDIVIDUAL_FINAL_STAGE_TITLE')
    },
    comment: {
      type: [String],
      default: BX.message('CATALOG_INDIVIDUAL_COMMENT')
    },
    error1: {
      type: [String],
      default: BX.message('CATALOG_INDIVIDUAL_ERROR_1')
    },
    error2: {
      type: [String],
      default: BX.message('CATALOG_INDIVIDUAL_ERROR_2')
    },
    error3: {
      type: [String],
      default: BX.message('CATALOG_INDIVIDUAL_ERROR_3')
    },
    error4: {
      type: [String],
      default: BX.message('CATALOG_INDIVIDUAL_ERROR_4')
    },
  },
  setup() {
    const {withMessage} = helpers;
    return {
      v$: useVuelidate(),
      withMessage
    }
  },
  validations() {
    return {
      commentField: {
        maxLength: this.withMessage(this.error1, maxLength(500))
      },
      quantityField: {
        maxValue: this.withMessage(this.error2, maxValue(999999)),
        minValue: this.withMessage(this.error3, minValue(1)),
        required: this.withMessage(this.error4, required)
      }
    }
  },
  data() {
    return {
      quantityField: 1,
    };
  },
  computed: {
    commentField: {
      get() {
        return this.getFormValueByKey('USER_COMMENT');
      },
      set(value) {
        this.setFormKey({key: 'USER_COMMENT', value});
      }
    },
    // quantityField: {
    //     get() {
    //         return this.getFormValueByKey('PRODUCT_QUANTITY');
    //     },
    //     set(value) {
    //         this.setFormKey({key: 'PRODUCT_QUANTITY', value});
    //     }
    // }
  },
  methods: {
    quantityPlus() {
      let tempQuantity;

      if (this.quantityField % 5 === 0) {
        tempQuantity = 5 * (this.quantityField / 5 + 1);
      } else {
        tempQuantity = 5 * Math.ceil(this.quantityField / 5);
      }

      if (tempQuantity < 999999) {
        this.quantityField = tempQuantity;
        this.quantityUpdate(this.quantityField);
      } else {
        this.quantityField = 999999;
        this.quantityUpdate(this.quantityField);
      }
    },
    quantityMinus() {
      let tempQuantity;

      if (this.quantityField % 5 === 0) {
        tempQuantity = 5 * (this.quantityField / 5 - 1);
      } else {
        tempQuantity = 5 * Math.floor(this.quantityField / 5);
      }

      if (tempQuantity > 1) {
        this.quantityField = tempQuantity;
        this.quantityUpdate(this.quantityField);
      } else {
        this.quantityField = 1;
        this.quantityUpdate(this.quantityField);
      }
    },
    quantityChange(event) {
      if (parseInt(event.target.value) > 999999)
        this.quantityField = 999999;
      else if (event.target.value === '' || parseInt(event.target.value) < 1)
        this.quantityField = 1;
      else if (event.target.value !== '')
        this.quantityField = Number(event.target.value);

      this.quantityUpdate(this.quantityField);
    },
    quantityInput(event) {
      if (event.target.value !== '' && !Number(event.target.value)) {
        this.quantityField = 1;
        this.quantityUpdate(this.quantityField);
      }
    },
    quantityUpdate(value) {
      this.setFormKey({key: 'PRODUCT_QUANTITY', value});
    },
    submitForm() {
      let _tmr = window._tmr || (window._tmr = []);
      _tmr.push({type: 'reachGoal', id: 3352405, goal: 'add_to_order'});

      this.v$.$validate().then((result) => {
        if (result) {
          this.$emit('submitForm');
        }
      })
    },
  }
}
</script>

<style scoped>

</style>